import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import TodayProductCollectionLayer from "../../../components/Admin/TodayProductCollectionLayer";

const TodayProductCollection = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <TodayProductCollectionLayer />
      </MasterLayout>
    </>
  );
};

export default TodayProductCollection